import ApiActivacion from '@/services/activacion/activacion.service'
import types from '@/store/modules/common/mutation-types-core'
const state = () => ({})
const getters = {}
const mutations = {}
const actions = {
    async putVerificar({ commit }, payload){
        try{
            let response = await ApiActivacion.putVerificar(payload);
            return response;
        }catch(error){
            throw new Error(error.message);
        }
    },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}